import styled from 'styled-components';
import { Row, Col } from 'antd';
import { I18n } from 'react-redux-i18n';

import DownloadModels from '../components/DownloadModels';
import UploadFiles from '../components/UploadFiles';
import SubmissionsHistory from '../components/SubmissionsHistory';
import WarningMessageSmallScreen from 'components/WarningMessageSmallScreen';
import Spinner from 'components/Spinner';
import Card from 'components/Card';
import CardHeader from 'components/CardHeader';

import { useSubmissions } from 'apiTyped/hooks/submission.query';
import { useUserMe } from 'apiTyped/hooks/users.query';

const NegoceSoumissionsContainer = styled.div`
  margin-top: 20px;

  display: flex;
  flex: 1;
  flex-direction: column;

  .width100 {
    width: 100%;
  }

  .m-0 {
    margin: 0;
  }

  .ml-1 {
    margin-left: 1rem;
  }

  .card-flex {
    height: 100%;
    background-color: white;
    border-radius: 4px;
  }

  @media (max-width: ${(props) =>
      props.theme.devices.isTablet ? '0px' : '845px'}) {
    max-width: calc(100vw - 15px);
  }
`;

const NegoceSoumissions = () => {
  const { user } = useUserMe();

  const { isLoadingSubmissions, submissions } = useSubmissions(
    user.client.id !== 0
  );

  return (
    <NegoceSoumissionsContainer>
      <Card>
        <CardHeader
          title={I18n.t('negoce.submissions.title')}
          fontSize="20px"
        />
        {window.innerWidth > 845 ? (
          <div style={{ marginTop: 20, marginBottom: 20 }}>
            <Row gutter={[16, 24]}>
              <Col span={24}>
                <DownloadModels />
              </Col>
              <Col className="gutter-row" sm={{ span: 24 }} xl={{ span: 12 }}>
                <div className="card-flex">
                  <UploadFiles />
                </div>
              </Col>
              <Col sm={{ span: 24 }} xl={{ span: 12 }}>
                <div className="card-flex">
                  <SubmissionsHistory submissions={submissions} />
                </div>
              </Col>
            </Row>
          </div>
        ) : (
          <WarningMessageSmallScreen />
        )}
        <Spinner loading={isLoadingSubmissions} />
      </Card>
    </NegoceSoumissionsContainer>
  );
};

export default NegoceSoumissions;
